// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".LanguageSelectorList-module-listWrapper-35f68{display:flex;flex-direction:column;align-items:flex-start;gap:10px;gap:var(--des-dimension-gap-and-padding-general-near-large, 10px);align-self:stretch}", ""]);
// Exports
exports.locals = {
	"listWrapper": "LanguageSelectorList-module-listWrapper-35f68"
};
module.exports = exports;
